import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const PenggunaService = {}

PenggunaService.data = function (token, data) {

    return fetch({
        url: '/pengaturan/pengguna/data',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

PenggunaService.detail = function (token, data) {

    return fetch({
        url: '/pengaturan/pengguna/detail',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

PenggunaService.data_import = function (token,data) {
    return fetch({
        url: '/pengaturan/pengguna/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

PenggunaService.empty_import = function (token,data) {
    return fetch({
        url: '/pengaturan/pengguna/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

PenggunaService.save_import = function (token,data) {
    return fetch({
        url: '/pengaturan/pengguna/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}
export default PenggunaService;
